"use strict";
/*
 * Created on 10.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WorkflowStatusConverter_1 = require("../../workflow/conversions/WorkflowStatusConverter");

var PromotionStateEnum_1 = require("../model/PromotionStateEnum");
/**
 * @author MSu
 */


var PromotionStatusConverter =
/*#__PURE__*/
function (_WorkflowStatusConver) {
  _inherits(PromotionStatusConverter, _WorkflowStatusConver);

  function PromotionStatusConverter() {
    _classCallCheck(this, PromotionStatusConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionStatusConverter).call(this, PromotionStateEnum_1.PromotionStateEnum));
  }

  return PromotionStatusConverter;
}(WorkflowStatusConverter_1.WorkflowStatusConverter);

exports.PromotionStatusConverter = PromotionStatusConverter;